<template>
  <div class="scjd-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button type="primary" icon="el-icon-check" @click="batchJd">批量接单</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  stripe
                  @selection-change="handleSelectionChange"
                  style="width: 100%">
                  <el-table-column
                    type="selection"
                    align="center"
                    fixed
                    width="55">
                  </el-table-column>
                  <el-table-column
                    label="订单号"
                    width="150"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="150"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计划交期"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.pmcplanned}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单金额"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF">{{scope.row.facamount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="色板来源"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.color_source}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分派工厂"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">{{scope.row.factory_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分派时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.send_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" type="warning">待接单</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-finished" @click.stop="factory(scope.row)">工厂接单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="工厂接单"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <!-- <div v-for="(item, index) in editForm.process" :key="item.key">
          <el-form-item :label="item.name" :prop="'process.' + index +'.process_name'">
            <el-date-picker
              disabled
              v-model="item.pmctime"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </div> -->
        <el-form-item label="计划交期" prop="PMCplanned">
          <el-date-picker
            disabled
            v-model="editForm.PMCplanned"
            type="date"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="接单备注" prop="content">
          <el-input type="textarea" v-model="editForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="editForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="editloading" @click="subEdit('editForm')">立即接单</el-button>
          <el-tooltip class="item" effect="dark" content="该订单暂不可拒接, 请联系系统管理员" placement="top" :disabled="(editForm.ismultifactory!==1)">
            <div style="display: inline-block">
              <el-button type="danger" icon="el-icon-close" :loading="editloading" :disabled="(editForm.ismultifactory === 1)" @click="turn('editForm')">拒接</el-button>
            </div>
          </el-tooltip>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderProductList, factoryOrders, batchScJd, selectPmcTimeList, exportOrderProductList } from '@/api/erp'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'scjd',
  computed: {
    user: getUser
  },
  components: {
    MultiFile,
    MultiImg
  },
  data() {
    return {
      exportLoading: false,
      searchForm: {
        type: '',
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      editForm: {
        orderid: '',
        ordername: '',
        content: '',
        files: [],
        imgids: [],
        process: [],
        PMCplanned: null,
        ismultifactory: 0
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写拒接原因', trigger: 'blur' }]
      },
      multipleSelection: [],
      factoryid: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          content: this.searchForm.search,
          groupid: this.user.dGroupid,
          mark: 11,
          userid: this.user.dUserid,
          role: this.user.role,
          type: this.searchForm.type,
          tableName: '生产接单列表'
        }
        exportOrderProductList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        mark: 11,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type,
        process: 11 // 生产接单
      }
      getOrderProductList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({
        path: '/work/order/' + row.order_id.substring(0, 36),
        query: {
          data: row.factory_id
        }
      })
    },
    factory(row) {
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.files = []
      this.editForm.imgids = []
      this.editForm.PMCplanned = row.pmcplanned
      this.factoryid = row.factory_id
      this.editForm.ismultifactory = row.ismultifactory
      this.editVisible = true
      // const data = {
      //   orderid: row.order_id
      // }
      // selectPmcTimeList(data).then(response => {
      //   this.editForm.process = response.data.orderProcessList
      //   this.editVisible = true
      // }).catch(() => {
      //   this.editVisible = false
      //   this.$message.error('出现错误')
      // })
    },
    turn(formName) {
      this.editRules.content[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubFactoryOrder(0)
        } else {
          return false
        }
      })
    },
    subEdit(formName) {
      this.editRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubFactoryOrder(1)
        } else {
          return false
        }
      })
    },
    SubFactoryOrder(ispass) {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid.substring(0, 36),
          reason: this.editForm.content,
          ispass: ispass,
          fileStr: this.editForm.files.join(','),
          imgStr: this.editForm.imgids.join(','),
          factoryid: this.factoryid
        }
        factoryOrders(data).then(response => {
          let msg = '接单成功'
          if (ispass === 0) {
            msg = '订单已拒接'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      // console.log(val)
    },
    batchJd() {
      if (this.multipleSelection.length === 0) {
        return false
      } else {
        this.$confirm(`您确定要批量操作此${this.multipleSelection.length}项订单吗？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          let orderIdArray = []
          for (let item of this.multipleSelection) {
            orderIdArray.push(item.order_id)
          }
          batchScJd({ userid: this.user.dUserid, orderIds: orderIdArray.join(',') }).then(response => {
            this.$message({
              message: '批量接单成功',
              type: 'success'
            })
            this.getData()
          })
        }).catch(() => {
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scjd-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
